import { useSelector } from 'react-redux'
import { getPcrIdSelector } from '../features/home/selectors/getPcrId.selector'

export const useAutofillGuardName = (fieldName: string): string => {
  const pcrId = useSelector(getPcrIdSelector)
  return pcrId ? `${fieldName}-${pcrId}` : fieldName
}
